import React from "react";
import './TauriBrand.css';

const TauriBrand = ({ brandname }) => {
    return (
        <a className="navbar-brand col-md-3 col-lg-2 m-0" href="#">
            {brandname}
        </a>
    );
};

export default TauriBrand;